import React from 'react';
import PropTypes from 'prop-types';
import mergeWith from 'lodash/mergeWith';

import HorizontalForm from 'components/form/horizontal_form';
import { defaultProperty, yesNoOptions, soilTypeOptions } from './assignment_constants';

export default class PropertyInfoSection extends React.Component {
  static propTypes = {
    property: PropTypes.object,
    onChange: PropTypes.func.isRequired
  }

  state = {
    expanded: false
  }

  toggleExpand = () => {
    this.setState((prevState) => {
      return { expanded: !prevState.expanded };
    });
  }

  renderAdditionalFields() {
    if (!this.state.expanded) return;

    const property = mergeWith(defaultProperty, this.props.property);
    const { onChange } = this.props;

    return (
      <React.Fragment>
        <HorizontalForm.Select
          name='irrigation'
          options={yesNoOptions}
          value={property.irrigation || ""}
          onChange={onChange}
        />
        <HorizontalForm.TextArea
          name='irrigationDescription'
          value={property.irrigationDescription || ""}
          onChange={onChange}
        />
        <HorizontalForm.Select
          name='water'
          options={yesNoOptions}
          value={property.water || ""}
          onChange={onChange}
        />
        <HorizontalForm.TextArea
          name='waterDescription'
          value={property.waterDescription || ""}
          onChange={onChange}
        />
        <HorizontalForm.Select
          name='telephone'
          options={yesNoOptions}
          value={property.telephone || ""}
          onChange={onChange}
        />
        <HorizontalForm.TextArea
          name='telephoneDescription'
          value={property.telephoneDescription || ""}
          onChange={onChange}
        />
        <HorizontalForm.Select
          name='cable'
          options={yesNoOptions}
          value={property.cable || ""}
          onChange={onChange}
        />
        <HorizontalForm.TextArea
          name='cableDescription'
          value={property.cableDescription || ""}
          onChange={onChange}
        />
        <HorizontalForm.Select
          name='sewer'
          options={yesNoOptions}
          value={property.sewer || ""}
          onChange={onChange}
        />
        <HorizontalForm.TextInput
          name='environmentalIssues'
          value={property.environmentalIssues}
          onChange={onChange}
        />
        <HorizontalForm.TextInput
          name='topography'
          value={property.topography}
          onChange={onChange}
        />
        <HorizontalForm.Select
          includeBlank
          name='soilType'
          options={soilTypeOptions}
          value={property.soilType}
          onChange={onChange}
        />
        <HorizontalForm.TextArea
          name='easementsDescription'
          value={property.easementsDescription || ""}
          onChange={onChange}
        />
      </React.Fragment>
    );
  }

  render() {
    const { property, onChange } = this.props;
    return (
      <React.Fragment>
        <h6 className="mb-2">Land Information</h6>
        <HorizontalForm.TextInput
          name='numberOfLots'
          number
          value={property.numberOfLots}
          onChange={onChange}
        />
        <HorizontalForm.TextInput
          name='bestUse'
          value={property.bestUse}
          onChange={onChange}
        />
        <div
          className='btn btn-light w-100 my-4'
          name='property-info-toggle'
          onClick={this.toggleExpand}
        >
          {`${this.state.expanded ? "Hide" : "Show"} Additional Fields`}
        </div>
        {this.renderAdditionalFields()}
      </React.Fragment>
    );
  }
}
